import React, { PropsWithChildren, RefObject } from 'react';
import { InputCounter } from '../../partials/InputCounter/InputCounter';
import { Icons, SVG } from '../../../../components/atoms/SVG';
import bem from '../../../../lib/bemUtils/bem';
import { Modifier } from '../../../../lib/bemUtils/Modifier';

export enum FieldWrapperModifier {
  PREFILLABLE_TEXT_INPUT = 'prefillable-text-input',
}

type FieldWrapper = {
  maxLength?: number;
  elementRef?: RefObject<HTMLInputElement | HTMLTextAreaElement | null>;
  modifier?: Modifier<FieldWrapperModifier>;
};
export function FieldWrapper({ maxLength, elementRef, modifier, children }: PropsWithChildren<FieldWrapper>) {
  return (
    // Reminder: This is a <span>, because we use this in a <p>. <div> in <p> is not allowed in HTML
    <span className={bem('field-wrapper', modifier)}>
      {children}
      <span className="field-wrapper__sibling">
        {maxLength && elementRef && <InputCounter maxLength={maxLength} elementRef={elementRef} />}
      </span>
      <span className="field-wrapper__warning" aria-hidden="true">
        <SVG svgSpriteId={Icons.FEEDBACK_ERROR} />
      </span>
    </span>
  );
}
